import React from "react";
import { Link } from "react-router-dom";
import { fetchAll, updateOne, deleteOne } from "actions/accessLevel";
import { connect } from "react-redux";
import DeleteModal from "components/DeleteModal";
import UpdateAccessLevelModal from "components/UpdateAccessLevelModal";
import { sortByProperty } from "utils";
import SortIndicator from "components/SortIndicator";

const list = byId => Object.keys(byId).map(id => byId[id]);

const mapStateToProps = state => ({
  accessLevels: list(state.accessLevel.byId),
  isFetchingClient: state.accessLevel.isFetching,
  deleteErrors: state.accessLevel.deleteErrors,
  isReady: list(state.accessLevel.byId) && !state.accessLevel.isFetching
});

const mapDispatchToProps = {
  fetchAll,
  updateOne,
  deleteOne
};

class AdminAccessLevelList extends React.Component {
  state = { sort: "user.company", sortReverse: false };

  componentWillMount() {
    this.props.fetchAll();
  }
  accessLevelApprove = accessLevel =>
    this.props.updateOne(accessLevel.id, { approved: true });

  accessLevelUnapprove = accessLevel =>
    this.props.updateOne(accessLevel.id, { approved: false });

  sortTable = (event, property) => {
    event.preventDefault();
    const { sort, sortReverse } = this.state;
    this.setState({
      sort: property,
      sortReverse: sort === property ? !sortReverse : sortReverse
    });
  };

  render() {
    const { isReady, deleteErrors } = this.props;
    const { sort, sortReverse } = this.state;
    const accessLevels = sortByProperty(
      this.props.accessLevels,
      sort,
      sortReverse
    );

    if (!isReady) {
      return <div>Spinner</div>;
    }
    return (
      <div>
        <Link to="/admin/accesslevel/create">
          <button className="btn btn-danger mb-2">Legg til adgangsnivå</button>
        </Link>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">
                <a onClick={e => this.sortTable(e, "id")} href="">
                  ID
                  <SortIndicator
                    sort={sort}
                    sortReverse={sortReverse}
                    colName="id"
                  />
                </a>
              </th>
              <th scope="col">
                <a onClick={e => this.sortTable(e, "user.company")} href="">
                  Firma
                  <SortIndicator
                    sort={sort}
                    sortReverse={sortReverse}
                    colName="user.company"
                  />
                </a>
              </th>
              <th scope="col">
                <a onClick={e => this.sortTable(e, "name")} href="">
                  Navn
                  <SortIndicator
                    sort={sort}
                    sortReverse={sortReverse}
                    colName="name"
                  />
                </a>
              </th>
              <th scope="col">Lesere</th>
              <th scope="col">Godkjent</th>
              <th scope="col">Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {accessLevels.map(accessLevel => (
              <tr key={accessLevel.id}>
                <th scope="row">{accessLevel.id}</th>
                <td>{accessLevel.user.company}</td>
                <td>{accessLevel.name}</td>
                <td>
                  <ul>
                    {sortByProperty(accessLevel.readers, "name").map(
                      ({ id, name }) => <li key={`${id}`}>{name}</li>
                    )}
                  </ul>
                </td>
                <td>
                  {accessLevel.approved ? (
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={() => this.accessLevelUnapprove(accessLevel)}
                    >
                      Godkjent
                    </button>
                  ) : (
                    <button
                      className="btn btn-danger"
                      type="button"
                      onClick={() => this.accessLevelApprove(accessLevel)}
                    >
                      Ikke godkjent
                    </button>
                  )}
                </td>
                <td>
                  <div className="btn-toolbar">
                    <UpdateAccessLevelModal
                      onSubmit={this.props.updateOne}
                      title={
                        "Redigerer ID " +
                        accessLevel.id +
                        " - " +
                        accessLevel.name
                      }
                      accessLevel={accessLevel}
                    />
                    <DeleteModal
                      errors={deleteErrors}
                      onDelete={this.props.deleteOne}
                      title={"[" + accessLevel.id + "] " + accessLevel.name}
                      id={accessLevel.id}
                    >
                      Adgangsnivå: {accessLevel.name}
                    </DeleteModal>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  AdminAccessLevelList
);



// WEBPACK FOOTER //
// ./src/components/AdminAccessLevelList.js